import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($filter, $scope, $state, $q, $stateParams, ModalService, ServiceRequestService, ViewModelService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.invoice = $state.$current.data.invoice;
        const withdrawalDTO = {
            invoiceID: $scope.invoice.publicID
        };
        $scope.withdrawalView = ViewModelService.create(withdrawalDTO, 'cc', 'edge.capabilities.servicerequest.statement.invoice.dto.InvoiceWithdrawalDTO');
    };

    ctrl.withdrawInvoice = (withdrawInvoiceForm) => {
        withdrawInvoiceForm.submitted = true;

        if (withdrawInvoiceForm.$valid && $scope.withdrawalView.aspects.subtreeValid) {
            $scope.withdrawInvoicePromise = ServiceRequestService.withdrawInvoice($scope.withdrawalView.value).then(
                (result) => {
                    if (result !== true) {
                        ModalService.showError(
                            'servicerequest.controllers.WithdrawInvoiceCtrl.Withdrawing invoice failed',
                            'servicerequest.controllers.WithdrawInvoiceCtrl.There seems to have been an issue with withdrawing'
                        ).result.then(() => {
                            $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $state.$current.data.serviceRequestNumber});
                        });
                    } else {
                        $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $state.$current.data.serviceRequestNumber});
                    }
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.WithdrawInvoiceCtrl.Withdrawing invoice failed',
                        'servicerequest.controllers.WithdrawInvoiceCtrl.There seems to have been an issue with withdrawing'
                    );
                }
            );
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$state', '$q', '$stateParams', 'ModalService', 'servicerequest.ServiceRequestService', 'ViewModelService'];
export default fn;
